<div *ngIf="showLoader" class="loader">
  <div class="loader-shapes"></div>
</div>
